import React from "react";
import { Globe } from "lucide-react";
import { LANGUAGES, useI18n } from "@/i18n";

export default function LanguageSwitcher() {
  const { lang, setLang } = useI18n();

  return (
    <div className="relative flex items-center">
      <Globe className="w-4 h-4 text-[#52635B] absolute left-2.5 pointer-events-none" />
      <select
        data-testid="language-switcher"
        value={lang}
        onChange={(e) => setLang(e.target.value)}
        aria-label="Language"
        className="appearance-none pl-8 pr-6 py-2 rounded-lg text-sm font-medium text-[#52635B] bg-transparent hover:bg-[#F1EFEB] transition-colors cursor-pointer outline-none border-0 focus:ring-2 focus:ring-[#0E382B]/20"
      >
        {LANGUAGES.map((l) => (
          <option key={l.code} value={l.code} data-testid={`lang-option-${l.code}`}>
            {l.flag} {l.label}
          </option>
        ))}
      </select>
    </div>
  );
}
